import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppStates } from '../application-controller/store/states';

@Injectable({
  providedIn: 'root'
})
export class AppTranslateLoader implements TranslateLoader {
  constructor(private store: Store<AppStates>) {}

  getTranslation(lang: any): Observable<any> {
    return this.store.select(state => state.translationState.languageJson).pipe(
      map(translations => translations[lang] || {}),
      catchError(() => of({})) // Return an empty object on error
    );
  }
}